function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import parseUrl from 'url-parse';
import Cookies from 'js-cookie';
import { hideLoadingOverlay, showLoadingOverlay } from './loadingOverlay';
import { createCart as createBTCheckoutCart, redirectToCheckout as redirectToBTCheckout } from './btCheckout';
import { initLILFlavorSelector } from './flavorSelector/index';
import { createClient, mutateCreateCart } from './storefrontApi';
import { pushCustomEvent, trackAddToCartEvent, trackBeginCheckoutEvent, trackersPush } from './trackers/utils';
import { appendTuneAttributes } from './trackers/hasoffers/index';
import { CheckoutProvider } from './enum';
import { StorefrontCartAdapter } from './trackers/adapater/cart/storefrontCartAdapter';
import { BTCheckoutCartAdapter } from './trackers/adapater/cart/btCheckoutCartAdapter';
import { getOfferCYPs } from './lockedInLanderOffers';
var _window$bt = window.bt,
    _window$bt$lil = _window$bt.lil;
_window$bt$lil = _window$bt$lil === void 0 ? {} : _window$bt$lil;
var fps = _window$bt$lil.fps,
    landerToken = _window$bt$lil.landerToken,
    pageHandle = _window$bt$lil.pageHandle,
    pageMetafieldExperimentId = _window$bt$lil.experimentId,
    _window$bt$lil$enable = _window$bt$lil.enabledCheckout,
    enabledCheckout = _window$bt$lil$enable === void 0 ? CheckoutProvider.BT_CHECKOUT : _window$bt$lil$enable,
    _window$bt$lil$storef = _window$bt$lil.storefrontApiToken;
_window$bt$lil$storef = _window$bt$lil$storef === void 0 ? {} : _window$bt$lil$storef;
var salesLandersApiToken = _window$bt$lil$storef.salesLanders,
    _window$bt$lil$optIn = _window$bt$lil.optIn,
    optIn = _window$bt$lil$optIn === void 0 ? null : _window$bt$lil$optIn,
    _window$bt$settings = _window$bt.settings;
_window$bt$settings = _window$bt$settings === void 0 ? {} : _window$bt$settings;
var vanityDomain = _window$bt$settings.vanityDomain,
    _window$bt$product = _window$bt.product;
_window$bt$product = _window$bt$product === void 0 ? {} : _window$bt$product;
var defaultSku = _window$bt$product.defaultSku;

var _ref = window.Shopify || {},
    shopifyDomain = _ref.shop;

var shopifyClient = createClient(shopifyDomain, salesLandersApiToken);

function enableProductFunnelBTCheckout(cyp) {
  // ensure no other click handlers are present
  $(cyp.selector).off('click');
  $(cyp.selector).on('click', /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(evt) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              evt.preventDefault();
              _context.next = 3;
              return sendToBTCheckout(cyp);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  $(cyp.selector).attr('href', '#');
}

function enableProductFunnelShopifyCheckout(cyp) {
  // ensure no other click handlers are present
  $(cyp.selector).off('click');
  $(cyp.selector).on('click', /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(evt) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              evt.preventDefault();
              _context2.next = 3;
              return sendToShopifyCheckout(cyp);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }());
  $(cyp.selector).attr('href', '#').css('cursor', 'pointer');
}

function sendToBTCheckout(_x3) {
  return _sendToBTCheckout.apply(this, arguments);
}

function _sendToBTCheckout() {
  _sendToBTCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(cyp) {
    var result;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (defaultSku) {
              _context3.next = 3;
              break;
            }

            console.error('Missing product data! Cannot obtain SKU to create checkout link.', {
              product: window.bt && window.bt.product
            });
            return _context3.abrupt("return");

          case 3:
            _context3.prev = 3;
            showLoadingOverlay();
            _context3.next = 7;
            return createBTCheckoutCart(_defineProperty({}, defaultSku, cyp.quantity));

          case 7:
            result = _context3.sent;

            if (result.success) {
              trackAddToCartEvent(new BTCheckoutCartAdapter(result.addedCartItems, result.cart));
              redirectToBTCheckout();
            } else {
              alert('Something went wrong.  Please try again.');
            }

            _context3.next = 15;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](3);
            console.error('Error adding to BT Checkout cart!', _context3.t0);
            hideLoadingOverlay();

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 11]]);
  }));
  return _sendToBTCheckout.apply(this, arguments);
}

export function sendToShopifyCheckout(_x4, _x5, _x6, _x7) {
  return _sendToShopifyCheckout.apply(this, arguments);
}

function _sendToShopifyCheckout() {
  _sendToShopifyCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(cyp, overrideVariantId, optInDealName, email) {
    var _window$btDataLayer, _window$bt2, _window$bt2$settings, _window$btDataLayer2, _cyp$sellingPlan, sessionId, agentId, lineItem, attributes, createCartPayload, checkout, cartAdapter, checkoutUrl, parsedUrl;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            console.debug('Shopify Checkout ENABLED');
            _context4.prev = 1;
            showLoadingOverlay();
            sessionId = (((_window$btDataLayer = window.btDataLayer) === null || _window$btDataLayer === void 0 ? void 0 : _window$btDataLayer.sessionId) || Cookies.get((_window$bt2 = window.bt) === null || _window$bt2 === void 0 ? void 0 : (_window$bt2$settings = _window$bt2.settings) === null || _window$bt2$settings === void 0 ? void 0 : _window$bt2$settings.sessionCookieName) || '').trim();
            agentId = (((_window$btDataLayer2 = window.btDataLayer) === null || _window$btDataLayer2 === void 0 ? void 0 : _window$btDataLayer2.agentId) || Cookies.get('bt') || '').trim();
            lineItem = {
              quantity: cyp.quantity,
              merchandiseId: "gid://shopify/ProductVariant/".concat(overrideVariantId || cyp.product.variants[0].id)
            };

            if (cyp !== null && cyp !== void 0 && (_cyp$sellingPlan = cyp.sellingPlan) !== null && _cyp$sellingPlan !== void 0 && _cyp$sellingPlan.id) {
              lineItem.sellingPlanId = "gid://shopify/SellingPlan/".concat(cyp.sellingPlan.id);
            }

            attributes = [{
              key: 'bt_lander',
              value: "".concat(pageHandle)
            }];

            if (landerToken) {
              attributes.push({
                key: 'bt_lander_token',
                value: "".concat(landerToken)
              });
            }

            if (optInDealName) {
              attributes.push({
                key: 'bt_lander_deal_name',
                value: optInDealName
              });
            }

            appendTuneAttributes(attributes);
            createCartPayload = {
              attributes: attributes,
              lines: [lineItem].concat(_toConsumableArray(cyp.freeReports)).map(function (vq) {
                return _objectSpread(_objectSpread({}, vq), {}, {
                  attributes: [{
                    key: '_bt_lander',
                    value: "".concat(pageHandle)
                  }, {
                    key: '_bt_lander_shipping',
                    value: fps ? 'flat-rate' : 'free'
                  }, {
                    key: '_cpSessionId',
                    value: sessionId || 'trackers-not-yet-initialized'
                  }, {
                    key: '_cpAgentId',
                    value: agentId || 'trackers-not-yet-initialized'
                  }]
                });
              }).reverse()
            };

            if (email) {
              createCartPayload.buyerIdentity = {
                email: email
              };
            }

            _context4.next = 15;
            return mutateCreateCart(shopifyClient, createCartPayload);

          case 15:
            checkout = _context4.sent;
            cartAdapter = new StorefrontCartAdapter(createCartPayload.lines, checkout.cart);
            trackAddToCartEvent(cartAdapter);
            trackBeginCheckoutEvent(cartAdapter);
            checkoutUrl = checkout.checkoutUrl;
            console.debug('[ShopifyCheckout] Shopify checkout created', {
              id: checkout.id,
              checkoutUrl: checkoutUrl,
              cart: JSON.stringify(checkout)
            });
            parsedUrl = parseUrl(checkoutUrl, true);

            if (parsedUrl.host === shopifyDomain && vanityDomain) {
              parsedUrl.host = vanityDomain;
            }

            window.location.assign(parsedUrl.toString(null));
            _context4.next = 30;
            break;

          case 26:
            _context4.prev = 26;
            _context4.t0 = _context4["catch"](1);
            window.alert(_context4.t0 && _context4.t0.message || 'Something went wrong');
            hideLoadingOverlay();

          case 30:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 26]]);
  }));
  return _sendToShopifyCheckout.apply(this, arguments);
}

function handleExperiment(_x8, _x9) {
  return _handleExperiment.apply(this, arguments);
} // the checkout split test should begin when a customer clicks "add to cart", rather than the default "page load"
// this ensures sessions that land on the page but do not buy are not counted and thus do not affect conversion rate
// setup:
//  GO: the "Activation event" in the "Settings" of the Optimize experiment needs to be set to a custom event
//  GTM: a datalayer variable needs to be created to hold the value of that event


function _handleExperiment() {
  _handleExperiment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(experimentVariation, cyp) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = experimentVariation;
            _context5.next = _context5.t0 === 1 ? 3 : _context5.t0 === 2 ? 7 : 11;
            break;

          case 3:
            console.debug('[split test] Shopify Checkout (Streamlined) enabled by experiment.', {
              experimentVariation: experimentVariation
            });
            _context5.next = 6;
            return sendToShopifyCheckout(cyp);

          case 6:
            return _context5.abrupt("break", 15);

          case 7:
            console.debug('[split test] Shopify Checkout (Non-Streamlined) enabled by experiment.', {
              experimentVariation: experimentVariation
            });
            _context5.next = 10;
            return sendToShopifyCheckout(cyp, true);

          case 10:
            return _context5.abrupt("break", 15);

          case 11:
            console.debug('[split test] BT Checkout enabled by experiment.', {
              experimentVariation: experimentVariation
            });
            _context5.next = 14;
            return sendToBTCheckout(cyp);

          case 14:
            return _context5.abrupt("break", 15);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _handleExperiment.apply(this, arguments);
}

function addOptimizeClickHandler(cyp) {
  // ensure no other click handlers are present
  $(cyp.selector).off('click');
  $(cyp.selector).on('click', function (evt) {
    evt.preventDefault();
    pushCustomEvent("".concat(pageHandle, ".optimize.activate"), 'split-test', window.location.pathname);
    getSplitTestPath().then(function (experimentVariation) {
      return handleExperiment(experimentVariation, cyp);
    })["catch"](function (err) {
      return console.error(err);
    });
  });
  $(cyp.selector).attr('href', '#');
}

function getSplitTestPath() {
  // if this promise fulfills first (ie, messagehub takes longer than 2 seconds to return), then default to control path
  var bailTimeout = new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(0);
    }, 2000);
  });
  var splitTestPath = new Promise(function (resolve) {
    trackersPush(function (trackers) {
      trackers.subscribe({
        topic: 'experiment',
        handler: function handler(_ref4) {
          var experimentId = _ref4.experimentId,
              experimentVariation = _ref4.experimentVariation;

          if (experimentId === pageMetafieldExperimentId) {
            resolve(parseInt(experimentVariation, 10));
          }
        }
      });
    });
  });
  return Promise.race([splitTestPath, bailTimeout]);
}

if (optIn) {
  // let optin.js handle the form interaction and processing checkout links
  console.debug('Opt-in lander recognized.', optIn);
} else {
  var nonFlavoredCheckoutFunc = enableProductFunnelBTCheckout;

  if (enabledCheckout === CheckoutProvider.SHOPIFY_CHECKOUT) {
    nonFlavoredCheckoutFunc = enableProductFunnelShopifyCheckout;
  } else if (enabledCheckout === CheckoutProvider.EXPERIMENT && pageMetafieldExperimentId) {
    nonFlavoredCheckoutFunc = addOptimizeClickHandler;
  }

  var offerCYPs = getOfferCYPs();
  offerCYPs.filter(function (cyp) {
    return !cyp.product.isOneThreeSixFlavor;
  }).forEach(nonFlavoredCheckoutFunc);
  initLILFlavorSelector({
    rootElement: document.body,
    flavorCYPs: offerCYPs.filter(function (cyp) {
      return cyp.product.isOneThreeSixFlavor;
    })
  });
  console.debug('LIL checkout links initialized');
}